<template>
  <v-dialog
    :value="value"
    @input="$emit('input', $event)"
    scrollable
    max-height="40vh"
    max-width="50vw"
    :fullscreen="$vuetify.breakpoint.smAndDown"
  >
    <v-card>
      <v-card-title>
        <span class="headline"> {{ firing.name }}</span>
        <v-spacer></v-spacer>
        <v-btn
          class="text-xs-right"
          flat
          icon
          color="black"
          @click="$emit('input', false)"
        >
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>
      <v-divider></v-divider>
      <v-card-text
        :style="`${
          $vuetify.breakpoint.smAndDown ? 'height: 55vh' : 'height: 40vh'
        }`"
      >
        <v-layout column>
          <v-layout
            row
            v-if="firing.simulated"
            class="pt-1 px-4 pb-1"
            justify-space-between
          >
            <strong>Simuladas</strong>
            <strong> {{ firing.simulated | numeral("0,0") }}</strong>
          </v-layout>
          <v-layout row class="pt-3 px-4 pb-1" justify-space-between>
            <strong>Enfileiradas</strong>
            <strong :class="`${queued == 0 ? 'red--text text--darken-3' : ''}`">
              {{ queued | numeral("0,0") }}
            </strong>
          </v-layout>
          <v-layout row class="pt-3 px-4 pb-1" justify-space-between>
            <strong>Enviadas</strong>
            <strong> {{ firing.notifications | numeral("0,0") }}</strong>
          </v-layout>
          <v-divider></v-divider>
          <div column>
            <div
              v-for="(skip, index) in firing.firing_skips"
              :key="firing.id + index"
              class="layout pt-3 px-4 pb-1 row justify-space-between"
            >
              <strong> {{ skip.skip_description }}</strong>
              <strong class="orange--text text--darken-3">
                {{ skip.skip_count | numeral("0,0") }}
              </strong>
            </div>
          </div>
          <v-layout
            row
            v-if="firing.missing > 0"
            class="pt-3 px-4 pb-1"
            justify-space-between
          >
            <strong>Notificações não processadas até o momento</strong>
            <strong
              :class="`${firing.missing > 0 ? 'red--text text--darken-3' : ''}`"
            >
              {{ (firing.missing > 0 ? firing.missing : 0) | numeral("0,0") }}
            </strong>
          </v-layout>
        </v-layout>
      </v-card-text>
      <v-divider></v-divider>
      <strong
        class="layout pt-3 px-5 pb-4 row justify-space-between"
        style="font-size: 18px"
      >
        Total de mensagens não enviadas
        <strong> {{ firing.not_sent | numeral("0,0") }}</strong>
      </strong>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    firing: {
      type: Object,
      default: () => ({}),
    },
  },
  computed: {
    queued() {
      return this.firing.type === "INCENTIVE"
        ? this.firing.notifications
        : this.firing.queued;
    },
  },
};
</script>
